import type { IWarehouseService } from './IWarehouseService';
import type { PagedResponse } from '../dto/PagedResponse';
import type { StockLevel } from '../dto/StockLevel.dto';
import type { Warehouse } from '../dto/Warehouse.dto';
import type { CreateWarehouseRequest } from '../dto/CreateWarehouseRequest';
import type { UpdateWarehouseRequest } from '../dto/UpdateWarehouseRequest';
import type { WarehouseType } from '../types/WarehouseType.type';
import { ListParams } from '../http/ListParams';
import { StockListParams } from '../http/StockListParams';
import { QueryBuilder } from '../http/QueryBuilder';
import { JsonRequestBody } from '../http/JsonRequestBody';
import { fetchWithAuth } from '../../../utils/fetch/FetchWithAuth';
import { ResourceType } from '../types';
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore

const BASE = '/api/warehouse/warehouse';

export class WarehouseService implements IWarehouseService {
    async list(
        params?: ListParams & { type?: WarehouseType },
    ): Promise<PagedResponse<Warehouse>> {
        return fetchWithAuth(
            `${BASE}${QueryBuilder.from(params).build()}`,
            {
                method: 'GET',
            },
        );
    }

    async get(externalId: string): Promise<Warehouse> {
        return fetchWithAuth(
            `${BASE}/${externalId}`,
            {
                method: 'GET',
            },
        );
    }

    async create(payload: CreateWarehouseRequest): Promise<Warehouse> {
        return fetchWithAuth(
            BASE,
            {
                method: 'POST',
                ...JsonRequestBody.from(payload),
            },
        );
    }

    async update(
        externalId: string,
        payload: UpdateWarehouseRequest,
    ): Promise<Warehouse> {
        return fetchWithAuth(
            `${BASE}/${externalId}`,
            {
                method: 'PATCH',
                ...JsonRequestBody.from(payload),
            },
        );
    }

    async updateStatus(
        externalId: string,
        status: string,
    ): Promise<Warehouse> {
        return fetchWithAuth(
            `${BASE}/${externalId}/status`,
            {
                method: 'PATCH',
                ...JsonRequestBody.from({ status }),
            },
        );
    }

    async getStock(
        externalId: string,
        params?: StockListParams,
    ): Promise<PagedResponse<StockLevel>> {
        return fetchWithAuth(
            `${BASE}/${externalId}/stock${QueryBuilder.from(params).build()}`,
            {
                method: 'GET',
            },
        );
    }

    async getResourceStock(
        warehouseId: string,
        resourceType: ResourceType,
        resourceId: string,
    ): Promise<StockLevel> {
        return fetchWithAuth(
            `${BASE}/${warehouseId}/stock/${resourceType}/${resourceId}`,
            { method: 'GET' },
        );
    }

}